import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ParamsSendLogs } from 'mbs-ui-shared@models/rm/remote-command-model';
import AccountManager from 'mbs-ui-shared@modules/support-portal/AccountManager';
import { Ticket, TicketResponse } from 'mbs-ui-shared@modules/support-portal/support-portal';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SupportPortalService {
  private http = inject(HttpClient);

  private readonly controllerPath = 'api/support-portal';
  public readonly photoPath = `${this.controllerPath}/get-photo?urlParams=`;

  getAccountManager(): Observable<AccountManager> {
    return this.http.get<AccountManager>(`${this.controllerPath}/get-account-manager`, { headers: { 'x-front-queue': 'true' } });
  }

  sendReportToSupport(params: Partial<Ticket>) {
    return this.http.post<TicketResponse>(`${this.controllerPath}/ticket`, params);
  }

  unreadMessagesCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${this.controllerPath}/ticket/count-unread`, { headers: { 'x-front-queue': 'true' } });
  }

  sendReportProblem(params: Partial<ParamsSendLogs>): Observable<boolean> {
    return this.http.post<boolean>(`${this.controllerPath}/ticket/report-error`, params);
  }
}
